import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { NoData } from '@swf/poker';

import {
  TXTWCL_No_Play_Money_standings,
  TXTWCL_No_Real_Money_standings,
  TXTWCL_You_will_see_standings_after_t_ELL_1,
  TXTWCL_You_will_see_standings_after_t_ELL_2
} from './NoStandings.messages.json';
import styles from './NoStandings.scss';

interface Props {
  className?: string;
  isPlayMoney: boolean;
}

const NoStandings: React.FC<Props> = ({ isPlayMoney, className }) => {
  const title = isPlayMoney ? TXTWCL_No_Play_Money_standings : TXTWCL_No_Real_Money_standings;
  const description = isPlayMoney
    ? TXTWCL_You_will_see_standings_after_t_ELL_1
    : TXTWCL_You_will_see_standings_after_t_ELL_2;
  return (
    <div className={classNames(styles.container, className)}>
      <NoData
        primaryText={<Translation {...title} />}
        secondaryText={<Translation {...description} />}
      />
    </div>
  );
};

export default NoStandings;
